(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as R, useQuery as ge, useLazyQuery as ke, useMutation as F, isApolloError as Be, useApolloClient as $e } from "@apollo/client";
import { getOperationName as K } from "@apollo/client/utilities";
import { jsx as s, jsxs as p, Fragment as U } from "react/jsx-runtime";
import { FormField as Z, FieldWrapper as G, Badge as j, Icon as ee, FlexBox as A, Text as S, List as ce, Banner as me, Button as P, Modal as Le, ModalHead as Fe, ModalBody as Ue, ModalFoot as Ge, Spinner as fe, Tag as He, Tooltip as pe, FieldText as de } from "@dixa/lib-shared-habla";
import { Link as qe } from "react-router-dom";
import { colors as I } from "@dixa/lib-shared-tokens";
import { useState as u, useEffect as T, createContext as he, useContext as Ce, createElement as z, useCallback as L } from "react";
import { FormProvider as Qe, useController as ze } from "react-hook-form";
import we from "moment";
import { useInterval as Ke } from "react-use";
import Ve from "lodash/lowerCase";
import Je from "lodash/upperFirst";
import { HookFormText as Ye } from "lib-shared-hook-form";
import Ze from "classnames";
import { MockedProvider as je } from "@apollo/client/testing";
import { render as Xe } from "@testing-library/react";
const te = R`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, ye = R`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ee = R`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ae = R`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, dn = (e, t) => function(n, o) {
  return ge(n, {
    ...o,
    context: {
      operationName: K(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, ln = (e, t) => function(n, o) {
  return ke(n, {
    ...o,
    context: {
      operationName: K(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, un = (e, t, n) => function(o, r) {
  return n.query({
    query: o,
    variables: r,
    context: {
      operationName: K(o),
      widgetId: e,
      widgetType: t
    }
  });
}, gn = (e, t) => function(n, o) {
  return F(n, {
    ...o,
    context: {
      operationName: K(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, mn = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ s(Z, { children: /* @__PURE__ */ s(G, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ s(U, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ p(U, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ s(j, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ s(qe, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, et = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", fn = ({
  errors: e
}) => e.some((t) => et({ error: t })), tt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", pn = ({
  errors: e
}) => e.some((t) => tt({ error: t })), nt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", hn = ({
  errors: e
}) => e.some((t) => nt({ error: t })), ot = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", Cn = ({
  errors: e
}) => e.some((t) => ot({ error: t })), rt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", wn = ({
  errors: e
}) => e.some((t) => rt({ error: t })), it = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", yn = ({
  errors: e
}) => e.some((t) => it({ error: t })), st = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", En = ({
  errors: e
}) => e.some((t) => st({ error: t })), at = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", An = ({
  errors: e
}) => e.some((t) => at({ error: t })), ct = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", bn = ({
  errors: e
}) => e.some((t) => ct({ error: t })), dt = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", lt = ({
  errors: e
}) => e.some((t) => dt({ error: t })), ut = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = u(!1);
  return T(() => {
    const i = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(i);
  }, [t, n]), { isCopied: n, copy: (i) => {
    navigator.clipboard.writeText(i), o(!0);
  } };
}, gt = "_errorWrapper_171rr_1", mt = "_copyIcon_171rr_5", J = {
  errorWrapper: gt,
  copyIcon: mt
}, ft = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const i = e && Be(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: c } = ut(), g = /* @__PURE__ */ s(
    ee,
    {
      color: I.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || i && lt({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ p(A, { margin: "0 0 100", padding: "200", className: J.errorWrapper, children: [
      /* @__PURE__ */ s(A, { margin: "0 300 0 0", alignItems: "center", children: g }),
      /* @__PURE__ */ s(S.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!i)
    return /* @__PURE__ */ s(A, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ s(
      ce.Item,
      {
        contentLeft: g,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const h = e?.graphQLErrors || [];
  return /* @__PURE__ */ p(
    A,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: J.errorWrapper,
      children: [
        h.map((l, m) => {
          const d = l?.extensions?.integration, C = d?.message || e?.message || "No error message available", w = d?.responseBody && JSON.parse(d?.responseBody), b = w?.errorMessages || [], N = w?.warningMessages || [], E = [...b, ...N].join(" ");
          return /* @__PURE__ */ s(
            ce.Item,
            {
              title: C,
              titleSecondary: E,
              contentLeft: g
            },
            m
          );
        }),
        !o && /* @__PURE__ */ p(A, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ s(
            me,
            {
              variant: "info",
              description: /* @__PURE__ */ s(S.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ p(A, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ s(P, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ s(
              P,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => c(JSON.stringify(h, null, 2)),
                className: J.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, pt = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: r,
  confirmLabel: i,
  cancelLabel: a = "Cancel",
  confirmVariant: c = "primary",
  cancelVariant: g = "secondary",
  isOpen: h,
  setIsOpen: l,
  showOnClose: m = !1
}) => /* @__PURE__ */ p(
  Le,
  {
    isOpen: h,
    onClose: () => {
      r && r(), l(!1);
    },
    children: [
      /* @__PURE__ */ s(
        Fe,
        {
          title: e,
          onClose: m ? r : void 0
        }
      ),
      /* @__PURE__ */ p(Ue, { children: [
        t && /* @__PURE__ */ s("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ s(
        Ge,
        {
          confirmOnClick: o ? () => {
            o(), l(!1);
          } : void 0,
          cancelOnClick: () => {
            r && r(), l(!1);
          },
          confirmName: i,
          cancelName: a,
          confirmProps: { variant: c },
          cancelProps: { variant: g }
        }
      )
    ]
  }
), ne = "The configuration of the integration is not correct. Please check the settings.", Nn = ({
  cause: e
}) => /* @__PURE__ */ s(A, { margin: "0 0 400", children: /* @__PURE__ */ s(
  me,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ p(A, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ s(S.Paragraph, { children: e || ne }),
      /* @__PURE__ */ p(A, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ s(S.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ s(S.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), Tn = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: r,
  isLoading: i,
  isWidgetUnknown: a,
  children: c
}) => o ? /* @__PURE__ */ s(ft, { error: o, retry: r }) : i ? /* @__PURE__ */ s(fe, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ p(S.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ s(He, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ s(Qe, { ...e, children: /* @__PURE__ */ s(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: c
  }
) });
function Mn(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const Sn = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Dn = (e) => {
  const t = Ve(e);
  return t.length === 0 ? e : Je(t);
}, be = "DD MMM YYYY @ HH:mm";
function ht(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function Ct(e, t) {
  return e == null ? t : String(e);
}
function On(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const xn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], In = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (i) => e.startsWith(i)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && r)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (r)
    return r;
};
function wt(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const oe = ["==", "!="], yt = [
  ...oe
], Et = [
  ...oe,
  "begins_with",
  "ends_with",
  "matches"
  // regex - https://github.com/dixahq/elevion/blob/f07a08fb5b0229925b1e42a2efad12870e3d46e1/elevion/src/test/scala/com/elevio/elevion/parser/ElevionParserTest.scala#L25
], At = [
  "contains_one",
  "contains_all",
  "is_empty"
], bt = ["between", "not_between"], Ne = [
  ...oe,
  ">",
  "<"
], Te = [
  "before",
  "after",
  ...Ne
], Nt = Te;
[
  // remove duplicates using Set
  .../* @__PURE__ */ new Set([
    ...yt,
    ...Et,
    ...At,
    ...bt,
    ...Te,
    ...Nt,
    ...Ne
  ])
];
const Tt = "custom__";
var X = /* @__PURE__ */ ((e) => (e.Queue = "system__queue", e.Tags = "system__tags", e))(X || {});
const Mt = (e) => e === X.Queue ? "Queue" : e === X.Tags ? "Tags" : e.startsWith(Tt) ? "Custom attribute" : e, Me = (e, t) => {
  if ("logicalOp" in e) {
    e.nodes.forEach((n) => Me(n, t));
    return;
  }
  t.add(Mt(e.field));
}, St = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => Me(n, t)), [...t].sort().join(", ");
}, le = (e, t, n, o) => {
  const r = n.length > 0, i = St(n);
  if (t) {
    r && e("settings:condition:created", { conditionType: i });
    return;
  }
  r ? e("settings:condition:updated", { conditionType: i }) : o && e("settings:condition:deleted", {});
}, Se = he(null);
function Dt() {
  const e = Ce(Se);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function Ot() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
const De = he(null), xt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  De.Provider
);
function It() {
  const e = Ce(De);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
function vn() {
  window._partner = {
    events: { emit: () => {
    } }
  };
}
const vt = {
  useMutation: F,
  // Returns an Apollo-shaped result so settings components that read a
  // per-widget query via `useWidgetContext()` (e.g. Klaviyo's subscribe-list
  // selector) can destructure it. Tests that need real query data wrap the
  // component in their own provider.
  useQuery: () => ({ data: void 0, loading: !1, error: void 0 }),
  useLazyQuery: () => [() => {
  }, { loading: !1 }],
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, Pt = {
  baseUrl: "http://localhost/graphql"
};
function Pn(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), r = vi.fn(), a = { ...{
    configuration: Pt,
    handleRedirect: o,
    showNotification: r
  }, ...n };
  return { ...Xe(
    z(
      je,
      { mocks: t },
      z(
        Se.Provider,
        { value: Ot() },
        z(
          xt,
          { value: vt },
          z(e, a)
        )
      )
    )
  ), handleRedirect: o, showNotification: r };
}
function _n({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: te,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              renderConditions: t?.renderConditions ?? [],
              settings: n
            }
          ]
        }
      }
    }
  };
}
function Wn({
  variables: e,
  result: t
}) {
  const n = {
    ...e,
    renderConditions: e.renderConditions ?? []
  };
  return {
    request: {
      query: Ee,
      variables: n
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? n.renderConditions,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function Rn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ye,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function kn({
  id: e
}) {
  return {
    request: {
      query: Ae,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function _t(e, t) {
  const n = {};
  for (const o of t) {
    const i = e.find((a) => a.key === o.key)?.value;
    o.secret && i === void 0 || (o.type === "boolean" ? n[o.key] = ht(i, o.defaultValue) : n[o.key] = Ct(i, o.defaultValue));
  }
  return n;
}
function Wt(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function Bn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: r,
  renderConditions: i
}) {
  const a = Wt(e, t), c = {
    name: e.name,
    enabled: e.enabled,
    settings: a,
    ...i !== void 0 && { renderConditions: i }
  };
  n ? await o(c) : await r(c);
}
function Rt(e) {
  const { user_id: t, iss: n } = wt(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function kt(e) {
  return e.startsWith("http://localhost");
}
function re() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const Bt = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: I.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: I.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: I.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: I.red[200],
        tooltip: "Connection timeout"
      };
    default:
      return {
        icon: "exclamation-circle-filled",
        color: I.neutral[500],
        tooltip: "Not connected"
      };
  }
}, $n = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [r, i] = u("CONNECTING"), [a, c] = u(""), [g, h] = u(null), { track: l } = re(), { icon: m, color: d, tooltip: C } = Bt(r), w = 3, b = 15, N = 2e3, [E, _] = u({}), [M, f] = u(0), [O, H] = u(N), [D, v] = u(!1), [W, k] = u(w), {
    isInboundOAuth: Oe,
    setIsInboundOAuth: xe,
    hasTriggeredAuthorization: Ie,
    setHasTriggeredAuthorization: ve
  } = Dt(), { baseUrl: q } = e, Pe = `${q}/auth/connect/${n.toLowerCase()}/${t}`, _e = `${q}/auth/status/${n.toLowerCase()}/${t}`, ie = r === "CONNECTING", se = (y) => Object.keys(y).length === 0, V = () => {
    v(!1), f(0);
  };
  T(() => {
    const y = localStorage.getItem("authData");
    if (y) {
      const x = JSON.parse(y ?? "{}").access_token;
      _({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${x}`,
          ...kt(q) && Rt(x)
        }
      });
    }
  }, [q]), T(() => {
    se(E) || v(!0);
  }, [E]);
  const We = () => {
    k(b), fetch(_e, { ...E }).then((y) => y.json()).then(({ data: y }) => {
      const { status: B, createdAt: x, createdByName: $ } = y;
      switch (B) {
        case "CONNECTING":
          i("CONNECTING");
          break;
        case "CONNECTED": {
          if (l("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), i("CONNECTED"), x && $) {
            const Q = new Date(x);
            isNaN(Q.getTime()) || h(Q), c($);
          }
          V();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          i(B), V();
      }
    }).catch((y) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        y
      ), i("CONNECTION_FAILED");
    });
  };
  Ke(
    () => {
      M >= W ? (i("CONNECTION_TIMEOUT"), V()) : (We(), f(M + 1));
    },
    D ? O : null
  );
  const ae = () => {
    l("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(Pe, { ...E }).then((y) => y.json()).then(({ data: y }) => {
      const { url: B } = y, x = 620, $ = 800, Q = window.innerWidth / 2 - x / 2, Re = window.innerHeight / 2 - $ / 2;
      i("CONNECTING"), v(!0), window.open(
        B,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${x},
						height=${$},
						left=${Q},
						top=${Re}`
      );
    }).catch((y) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        y
      ), i("CONNECTION_FAILED");
    });
  };
  return T(() => {
    Oe && !Ie && !se(E) && (ve(!0), xe(!1), ae());
  }, [E]), /* @__PURE__ */ p(U, { children: [
    /* @__PURE__ */ s(Z, { span: 3, children: /* @__PURE__ */ s(
      G,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ p(A, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ s(
            P,
            {
              icon: "key",
              variant: "secondary",
              onClick: ae,
              disabled: ie,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ s(pe, { content: C, children: ie ? /* @__PURE__ */ s(fe, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ p(A, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ s(
              ee,
              {
                "data-testid": "oauth-button-status-icon",
                name: m,
                color: d
              }
            ),
            r === "CONNECTED" && a && g && /* @__PURE__ */ p(S.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              we(g).format(be)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ s(Z, { span: 3 })
  ] });
}, Ln = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ s(S.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ s(
      ee,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? I.green[500] : I.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ s(j, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), r = o.startsWith("-"), i = o === "0", a = r ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ s(S.Paragraph, { variant: "5", color: "secondary", children: i ? "today" : a });
  }
  const n = we(e);
  return n.isValid() ? /* @__PURE__ */ s(S.Paragraph, { variant: "5", color: "secondary", children: n.format(be) }) : /* @__PURE__ */ s(j, { variant: "info", size: "small", children: e });
}, Fn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: r } = e, [i, a] = u(t);
  if (!i) {
    const c = typeof n == "string" ? n : "";
    return /* @__PURE__ */ s(G, { label: n, helpIcon: o, children: /* @__PURE__ */ p(
      P,
      {
        "data-testid": `secret-field-button-${r}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          c
        ]
      }
    ) });
  }
  return /* @__PURE__ */ s(
    $t,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, $t = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, r = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ s(
    Ye,
    {
      ...e,
      componentProps: r,
      shouldUnregister: !0
    }
  );
}, Lt = "_wrapper_1lmim_1", Ft = "_wrapperBox_1lmim_4", Ut = "_wrapperBoxErrorBorder_1lmim_9", Y = {
  wrapper: Lt,
  wrapperBox: Ft,
  wrapperBoxErrorBorder: Ut
}, ue = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", Un = (e) => {
  const { isCreationMode: t = !1, label: n, name: o } = e, [r, i] = u(t);
  if (!r) {
    const a = typeof n == "string" ? n : "";
    return /* @__PURE__ */ s(G, { label: n, children: /* @__PURE__ */ p(
      P,
      {
        "data-testid": `secret-field-button-${o}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => i(!0),
        children: [
          "Update ",
          a
        ]
      }
    ) });
  }
  return /* @__PURE__ */ s(
    Gt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => i(!1)
    }
  );
}, Gt = (e) => {
  const {
    name: t,
    control: n,
    label: o,
    rules: r,
    isCreationMode: i,
    usernameLabel: a,
    passwordLabel: c,
    usernamePlaceholder: g,
    passwordPlaceholder: h,
    onClose: l
  } = e, { field: m, fieldState: d } = ze({
    name: t,
    control: n,
    rules: r,
    shouldUnregister: !0
  }), [C, w] = u(""), [b, N] = u(""), E = (f) => {
    w(f), m.onChange(ue(f, b));
  }, _ = (f) => {
    N(f), m.onChange(ue(C, f));
  }, M = !!r?.required;
  return /* @__PURE__ */ s(
    G,
    {
      label: o,
      required: M,
      meta: {
        touched: d.isTouched,
        error: d.error?.message
      },
      className: Y.wrapper,
      children: /* @__PURE__ */ p(
        A,
        {
          gap: "300",
          flexDirection: "column",
          className: Ze(Y.wrapperBox, {
            [Y.wrapperBoxErrorBorder]: !!d.error
          }),
          children: [
            /* @__PURE__ */ s(
              de,
              {
                noAlert: !0,
                required: M,
                label: a,
                placeholder: g,
                input: {
                  name: t,
                  value: C,
                  onChange: (f) => E(f?.target.value ?? ""),
                  onBlur: m.onBlur
                },
                ...!i && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            ),
            /* @__PURE__ */ s(
              de,
              {
                noAlert: !0,
                required: M,
                label: c,
                placeholder: h,
                input: {
                  name: t,
                  value: b,
                  onChange: (f) => _(f?.target.value ?? ""),
                  onBlur: m.onBlur
                },
                ...!i && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
}, Ht = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Gn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: r,
  automationCouplingState: i,
  onConfirmDelete: a,
  labels: c,
  deleteConfirmationBody: g,
  confirmDeleteVariant: h = "primary"
}) => {
  const { track: l } = re(), [m, d] = u(!1), C = { ...Ht, ...c }, w = !i || !i.isCoupled, b = () => {
    t && l("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), d(!0);
  }, N = () => {
    t && l("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ p(U, { children: [
    /* @__PURE__ */ p(A, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ s(P, { type: "submit", isLoading: r, disabled: r, children: C.submit }),
      !o && /* @__PURE__ */ s(
        pe,
        {
          content: "The widget is used in automations",
          disabled: w,
          children: /* @__PURE__ */ s(
            P,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: b,
              disabled: !w,
              isLoading: i?.isLoading,
              children: C.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ s(
      pt,
      {
        isOpen: m,
        setIsOpen: d,
        confirmVariant: h,
        confirmLabel: C.confirmDelete,
        cancelLabel: C.cancelDelete,
        onCancel: N,
        onConfirm: a,
        children: /* @__PURE__ */ s(A, { children: g ?? /* @__PURE__ */ p(U, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, qt = R`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Qt = R`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Hn(e) {
  const { useQuery: t, useMutation: n } = It(), [o, r] = u(), [i, a] = u(), [c, g] = u(!1), {
    loading: h,
    data: l,
    error: m
  } = t(
    qt,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [d, { loading: C, error: w }] = n(
    Qt
  ), b = async (N, E) => await d({
    variables: {
      conversationId: (E ?? e)?.toString(),
      data: N
    }
  }).then(
    ({ data: M }) => r(M?.Storage?.storeWidgetData?.data ?? {})
  );
  return T(() => {
    !h && l && r(l?.Storage?.widgetData ?? {});
  }, [l, h]), T(() => m && a(m), [m]), T(() => g(h), [h]), T(() => w && a(w), [w]), T(() => g(C), [C]), {
    data: o,
    loading: c,
    store: b,
    error: i
  };
}
const qn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: r } = re(), [i, a] = u(!1), [c, g] = u(), [h, l] = u(null), m = L(
    (f) => (O) => {
      g(O), a(!1), o({
        title: "Something went wrong",
        text: `The ${f} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [d] = F(Ee, {
    onError: m("creation")
  }), [C] = F(ye, {
    onError: m("update")
  }), [w] = F(Ae, {
    onError: m("deletion")
  }), b = $e(), N = L(() => e ? !!b.readQuery({
    query: te,
    variables: { id: e }
  })?.Management?.widgetConfigurations?.[0]?.renderConditions?.length : !1, [b, e]), E = L(
    async ({
      name: f,
      enabled: O,
      settings: H,
      renderConditions: D = []
    }) => {
      r("settings:create:submitted", { widgetType: t }), a(!0), g(void 0);
      const { data: v } = await d({
        variables: {
          type: t,
          name: f,
          enabled: O,
          settings: H,
          renderConditions: D
        }
      });
      a(!1);
      const W = v?.Management?.createWidgetConfiguration;
      if (!W) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      le(r, !0, D, !1), o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(W.id);
    },
    [d, n, t, o, r]
  ), _ = L(
    async ({
      name: f,
      enabled: O,
      settings: H,
      renderConditions: D
    }) => {
      if (!e)
        return;
      r("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      });
      const v = N();
      a(!0), g(void 0);
      const { data: W } = await C({
        variables: {
          id: e,
          name: f,
          enabled: O,
          settings: H,
          ...D !== void 0 && { renderConditions: D }
        }
      });
      a(!1);
      const k = W?.Management?.updateWidgetConfiguration;
      if (!k) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      k.misconfigured ? l(
        k.misconfigurationCause ?? ne
      ) : l(null), D && le(
        r,
        !1,
        D,
        v
      ), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [
      e,
      t,
      N,
      o,
      r,
      C
    ]
  ), M = L(async () => {
    if (!e)
      return;
    r("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), g(void 0);
    const { data: f } = await w({
      variables: { id: e }
    });
    a(!1), f?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    w,
    n,
    e,
    t,
    o,
    r
  ]);
  return {
    create: E,
    update: _,
    remove: M,
    isLoading: i,
    error: c,
    misconfigurationCause: h,
    setMisconfigurationCause: l
  };
};
function Qn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [r, i] = u(!1), [a, c] = u(), { loading: g, error: h, refetch: l } = ge(te, {
    variables: { id: e },
    skip: !e,
    onCompleted: (m) => {
      const d = m?.Management?.widgetConfigurations?.[0];
      if (!d) {
        i(!0), c(void 0);
        return;
      }
      i(!1), c(d), n.reset({
        ..._t(d.settings ?? [], t),
        enabled: !!d.enabled,
        name: d.name
      }), d.misconfigured && o?.(
        d.misconfigurationCause ?? ne
      );
    }
  });
  return T(() => {
    i(!1), c(void 0);
  }, [e]), {
    isLoading: g,
    error: h,
    isWidgetUnknown: r,
    refetch: l,
    widgetConfiguration: a
  };
}
function zn({
  integrationId: e,
  widgetConfiguration: t,
  renderConditionsEditor: n
}) {
  const o = !e, [r, i] = u(o ? [] : null);
  return T(() => {
    i(o ? [] : null);
  }, [e, o]), T(() => {
    t && r === null && i(t.renderConditions ?? []);
  }, [t, r]), {
    renderConditions: r,
    setRenderConditions: i,
    renderConditionsForSubmit: !!n && r !== null && r !== null ? r : void 0
  };
}
export {
  ft as DisplayErrors,
  mn as DixaApiTokenSettings,
  Se as InboundOAuthContext,
  pt as IntegrationModal,
  Nn as MisconfigurationBanner,
  $n as OAuthSettings,
  Un as PartnerHookFormBasicAuth,
  Fn as PartnerHookFormSecretText,
  Tn as PartnerSettingsWrapper,
  xt as WidgetContextProvider,
  Gn as WidgetSettingsFormFooter,
  Sn as capitalizeFirstCharacter,
  xn as countryCodes,
  Ot as createMockInboundOAuthContextOptions,
  Wn as createWidgetConfigurationCreateMock,
  kn as createWidgetConfigurationDeleteMock,
  Ee as createWidgetConfigurationMutation,
  _n as createWidgetConfigurationQueryMock,
  Rn as createWidgetConfigurationUpdateMock,
  Mn as deepClone,
  be as defaultDateFormat,
  ne as defaultMisconfigurationCause,
  Pt as defaultPartnerSettingsConfiguration,
  vt as defaultWidgetContextValue,
  Ae as deleteWidgetConfigurationMutation,
  Ln as displayAttributeValue,
  Wt as formValuesToSettings,
  St as getConditionType,
  Bt as getConnectionStatusValues,
  On as getCountryNameFromCountryCode,
  Rt as getPartnerDevApiHeaders,
  te as getWidgetConfigurationByIdQuery,
  Bn as handleWidgetSubmit,
  fn as hasDixaHeaderCheckError,
  pn as hasDownstreamApiAuthorizationError,
  En as hasDownstreamApiBadRequestError,
  yn as hasDownstreamApiConflictError,
  An as hasDownstreamApiForbiddenError,
  wn as hasDownstreamApiNotFoundError,
  hn as hasDownstreamApiPermissionError,
  Cn as hasDownstreamApiServiceUnavailableError,
  bn as hasDownstreamApiTooManyRequestsError,
  lt as hasWidgetMisconfiguredError,
  Dn as humanizeKey,
  et as isDixaHeaderCheckError,
  tt as isDownstreamApiAuthorizationError,
  st as isDownstreamApiBadRequestError,
  it as isDownstreamApiConflictError,
  at as isDownstreamApiForbiddenError,
  rt as isDownstreamApiNotFoundError,
  nt as isDownstreamApiPermissionError,
  ot as isDownstreamApiServiceUnavailableError,
  ct as isDownstreamApiTooManyRequestsError,
  kt as isRunningLocalPartnerApi,
  dt as isWidgetMisconfiguredError,
  un as makeExecuteQuery,
  ln as makeUseLazyQuery,
  gn as makeUseMutation,
  dn as makeUseQuery,
  wt as parseAccessToken,
  ht as parseBoolean,
  Ct as parseString,
  Pn as renderPartnerSettings,
  _t as settingsToFormValues,
  vn as stubPartnerEventsBusForTests,
  le as trackRenderConditionsSaved,
  ye as updateWidgetConfigurationMutation,
  ut as useCopyWithDelay,
  Hn as useData,
  Dt as useInboundOAuthContext,
  zn as useRenderConditions,
  re as useTracking,
  It as useWidgetContext,
  qn as useWidgetSettingsMutations,
  Qn as useWidgetSettingsQuery,
  In as validateApiHostName
};
